import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../Auth/AuthProvider";
import {
  VerifyAnyPermission,
  VerifyPermission,
} from "../../Funcoes/VerifyPermission";
import {
  ANY_PRODUTOS_ACCESS,
  ANY_WORKFLOW,
  PERM_CONSULTAR,
} from "./shared/permissions";

/**
 * Redireciona a raiz do módulo para a primeira tela que o usuário pode ver.
 */
const CadastrosIndexRedirect = () => {
  const { user } = useContext(AuthContext);

  if (VerifyAnyPermission(user, ANY_WORKFLOW)) {
    return <Navigate to="dashboard" replace />;
  }

  if (
    VerifyPermission(user, PERM_CONSULTAR) ||
    VerifyAnyPermission(user, ANY_PRODUTOS_ACCESS)
  ) {
    return <Navigate to="produtos/consulta" replace />;
  }

  return <Navigate to="/modules" replace />;
};

export default CadastrosIndexRedirect;
